import Mutations from '../../odata/mutations';

export default { ...new Mutations('driedCookingProcessCheck'), ...new Mutations('driedCookingProcessChecks') };
